import React, { useEffect, useState } from 'react';
import { Bell } from 'lucide-react';
import { supabase } from '../../db/engine';

export default function Header({ title }) {
  const [alertas, setAlertas] = useState(0);

  useEffect(() => {
    (async () => {
      const today = new Date().toISOString().split('T')[0];
      const in60 = new Date(Date.now() + 60*86400000).toISOString().split('T')[0];
      const { count: venc } = await supabase.from('polizas').select('*', { count:'exact', head:true })
        .gte('fecha_vencimiento', today).lte('fecha_vencimiento', in60).eq('estado','activa');
      const { count: mor } = await supabase.from('pagos').select('*', { count:'exact', head:true })
        .eq('estado','pendiente').lt('fecha_vencimiento', today);
      setAlertas((venc || 0) + (mor || 0));
    })().catch(() => {});
  }, []);

  return (
    <div style={{ height:64, background:'rgba(var(--navy-rgb),0.95)', borderBottom:'1px solid rgba(var(--silver-rgb),0.15)', display:'flex', alignItems:'center', padding:'0 24px', gap:16, backdropFilter:'blur(10px)', flexShrink:0 }}>
      <div style={{ flex:1 }}><div style={{ fontSize:18, fontWeight:700 }}>{title}</div></div>
      <div style={{ display:'flex', alignItems:'center', gap:12 }}>
        <div style={{ position:'relative' }}>
          <button style={{ background:'rgba(var(--steel-rgb),0.4)', border:'1px solid rgba(var(--silver-rgb),0.2)', borderRadius:8, padding:8, cursor:'pointer', color:'var(--silver)', display:'flex', alignItems:'center', position:'relative' }}>
            <Bell size={16} />
            {alertas > 0 && <span style={{ position:'absolute', top:4, right:4, width:8, height:8, borderRadius:'50%', background:'#EF4444', border:'2px solid var(--navy)' }} />}
          </button>
        </div>
        <div style={{ fontSize:13, color:'var(--silver)' }}>{new Date().toLocaleDateString('es-PA', { weekday:'short', month:'short', day:'numeric' })}</div>
      </div>
    </div>
  );
}
